// @flow
import * as React from 'react';
import { globalize, localize } from '@ta/common.i18n';
import SocialCounts from './SocialCounts';

type Props = {|
  contributionCount?: number,
|};

const ActorSocialCounts = ({ contributionCount }: Props) => (
  <SocialCounts>
    {contributionCount !== undefined
      ? localize(
          'social_profile_contributions' /* {0, plural, one{# contribution} other{# contributions}} */,
          { '0': globalize.formatNumber('integer', contributionCount) },
        )
      : null}
  </SocialCounts>
);

/** The ActorSocialCounts component */
export default React.memo<Props>(ActorSocialCounts);
